import { ComponentProps } from "react";
import { ApolloError } from "@apollo/client";
import { spacing } from "../../../../stitches.config";
import { EmptyState } from "../../../Common/EmptyState";
import RecentJobsTable from "../RecentJobsTable";

export type FirmImportsProps = {
  error?: Pick<ApolloError, "message">;
} & Pick<
  ComponentProps<typeof RecentJobsTable>,
  "recentJobs" | "loading" | "manualPaginationConfig"
>;

const FirmImports = ({
  recentJobs,
  error,
  loading,
  manualPaginationConfig,
}: FirmImportsProps) => {
  if (error) return <div>Error loading recent imports.</div>;

  const hasRecentFirmImports = !!recentJobs.length;

  return (
    <>
      {!loading && (
        <>
          {hasRecentFirmImports ?
            <RecentJobsTable
              recentJobs={recentJobs}
              loading={loading}
              manualPaginationConfig={manualPaginationConfig}
              loadingText="Loading recent imports"
              noDataText="No recent imports found"
            />
          : <EmptyState
              icon="missing-location"
              title="No recent imports for this account"
              body="FIRM imports for this account will appear here."
              paddingTop={spacing["2xl"].value}
              paddingBottom={spacing["2xl"].value}
            />
          }
        </>
      )}
    </>
  );
};

export default FirmImports;
